import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import moment from '../../../lib/moment.js'
import get from 'lodash/get'
import set from 'lodash/set'
import { Container } from 'reactstrap'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import {
  modalAction,
  authAction,
  reportAction,
} from './../../../actions/'
import {
  modalSelector,
  authSelector,
  reportSelector,
} from './../../../selectors'
import SubcontractCostTable from '../../../components/report/table/subcontract-cost'
import Searchbar from '../../../components/searchbar-report/subcontract'
import withLayout from '../../../helpers/withLayout'
import * as reportHelper from '../../../components/report/helpers/report'

class SubcontractReport extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'exportSubcontractData')) {
      window.open(get(nextProps, 'exportSubcontractData'))
      nextProps.resetExportSubcontract()
    }
    const subContractCosts = get(nextProps, 'getSubcontractReportData.subContractCosts')
    if (get(nextProps, 'getSubcontractReportData.subContractCosts')) {
      set(tempState, 'subContractCosts', get(nextProps, 'getSubcontractReportData.subContractCosts'))
      set(tempState, 'subContractCosts', reportHelper.generateSubcontractReportList(
        get(subContractCosts, 'subContractCosts'),
        get(subContractCosts, 'users'),
        get(subContractCosts, 'projects')
      ))
      set(tempState, 'users', get(subContractCosts, 'users'))
      set(tempState, 'projects', get(subContractCosts, 'projects'))
    }
    return tempState
  }

  state={
    startDate: moment().subtract(1, 'months').startOf('month'),
    endDate: moment().subtract(1, 'months').endOf('month'),
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getSubcontractReport(
      moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
      moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
      access_token)
  }

  handleDate = (type, data) => {
    const access_token = localStorage.getItem('access_token')
    const { startDate, endDate } = this.state

    switch (type) {
      case 'start_date': {
        this.setState({ startDate: data })
        this.props.getSubcontractReport(moment(data).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), access_token)
        break
      }
      default: {
        this.setState({ endDate: data })
        this.props.getSubcontractReport(moment(startDate).format('YYYY-MM-DD'), moment(data).format('YYYY-MM-DD'), access_token)
        break
      }
    }
  }

  render() {
    const isFetching = get(this.props, 'getIsFetching')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsAccountantUser = get(this.props, 'authData.user.is_accountant_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectReport.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
    || get(this.props, 'redirectReport.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    if (IsAccountantUser !== undefined &&
      IsSystemUser !== undefined &&
      !(IsSystemUser || IsAccountantUser)) window.location = '/home'
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <Searchbar
          { ...this.state }
          exportSubcontract={ this.props.exportSubcontract }
          handleDate={ (type, data) => this.handleDate(type, data) }
          handleSearch={ (search) => this.setState({ searchSubcontract: search }) }
        />
        <SubcontractCostTable
          searchSubcontract={ this.state.searchSubcontract }
          subContractCosts={ this.state.subContractCosts }
          users={ this.state.users }
          projects={ this.state.projects }
        />
      </Wrapper>
    )
  }
}
SubcontractReport.propTypes = {
  getAuth: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
  exportSubcontract: PropTypes.func.isRequired,
  resetExportSubcontract: PropTypes.func.isRequired,
  getSubcontractReport: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  getIsFetching: reportSelector.getIsFetching,
  redirectAuth: authSelector.redirectAuth,
  redirectReport: reportSelector.redirectReport,
  exportSubcontractData: reportSelector.exportSubcontractData,
  getSubcontractReportData: reportSelector.getSubcontractReportData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  exportSubcontract: reportAction.exportSubcontractReport,
  resetExportSubcontract: reportAction.resetExportSubcontractReport,
  getSubcontractReport: reportAction.getSubcontractReport,
  resetGetSubcontractReport: reportAction.resetGetSubcontractReport,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(withLayout(SubcontractReport))

const Wrapper = styled(Container)`
  padding: 0px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/report/subcontract/index.js